<script lang="ts" setup>
</script>

<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0474 8.55533V7.44067H16.5639V8.55533H14.986V12.681H13.6253V8.55533H12.0474Z"
      fill="#5061FA"
    />
    <path
      d="M17.7509 12.681H16.2599L18.0043 7.44067H19.8789L21.6161 12.681H20.1323L19.8174 11.6532H18.0622L17.7509 12.681ZM18.3807 10.6109H19.4989L18.9597 8.85209H18.9163L18.3807 10.6109Z"
      fill="#5061FA"
    />
    <path
      d="M23.5921 7.44067L24.4751 9.00409H24.5185L25.416 7.44067H26.9578L25.3871 10.0608L27.0157 12.681H25.4378L24.5185 11.0959H24.4751L23.5631 12.681H21.9924L23.6065 10.0608L22.0431 7.44067H23.5921Z"
      fill="#5061FA"
    />
    <path
      d="M30.3828 33.612H9.61727C8.08793 33.612 6.89058 32.415 6.89058 30.8862V28.5701C6.89058 28.1431 7.23645 27.7988 7.66288 27.7988C8.08932 27.7988 8.43519 28.1431 8.43519 28.5701V30.8862C8.43519 31.55 8.954 32.0693 9.61727 32.0693H30.3828C31.0092 32.0693 31.5183 31.5388 31.5183 30.8862V2.67921C31.5183 2.06408 30.9988 1.54337 30.3828 1.54337H9.61727C8.96511 1.54337 8.43519 2.05367 8.43519 2.67921V25.4355C8.43519 25.8624 8.08932 26.2068 7.66288 26.2068C7.23645 26.2068 6.89058 25.8624 6.89058 25.4355V2.67921C6.89058 1.20179 8.11363 0 9.61727 0H30.3828C31.8607 0 33.0636 1.20179 33.0636 2.67921V30.8862C33.0636 32.39 31.8607 33.612 30.3828 33.612Z"
      fill="#5061FA"
    />
    <path
      d="M19.9775 26.9886H12.7982C12.3718 26.9886 12.0259 26.6442 12.0259 26.2172C12.0259 25.7903 12.3718 25.4459 12.7982 25.4459H19.9775C20.4039 25.4459 20.7498 25.7903 20.7498 26.2172C20.7498 26.6442 20.4039 26.9886 19.9775 26.9886Z"
      fill="#5061FA"
    />
    <path
      d="M27.2026 23.2644H12.7982C12.3718 23.2644 12.0259 22.9201 12.0259 22.4931C12.0259 22.0661 12.3718 21.7218 12.7982 21.7218H27.2026C27.629 21.7218 27.9749 22.0661 27.9749 22.4931C27.9749 22.9201 27.629 23.2644 27.2026 23.2644Z"
      fill="#5061FA"
    />
    <path
      d="M27.2026 19.5396H12.7982C12.3718 19.5396 12.0259 19.1953 12.0259 18.7683C12.0259 18.3413 12.3718 17.997 12.7982 17.997H27.2026C27.629 17.997 27.9749 18.3413 27.9749 18.7683C27.9749 19.1953 27.629 19.5396 27.2026 19.5396Z"
      fill="#5061FA"
    />
    <path
      d="M32.4052 40C32.2475 40 32.0899 39.9875 31.9315 39.959L11.482 36.371C11.0625 36.2974 10.7813 35.8968 10.8549 35.4775C10.9292 35.0581 11.3244 34.7797 11.7494 34.8499L32.1968 38.4379C32.499 38.4927 32.8087 38.424 33.0615 38.2504C33.3115 38.0782 33.4768 37.82 33.5289 37.5228L33.9373 35.2039C34.0116 34.7846 34.4103 34.5027 34.8319 34.5777C35.252 34.6513 35.5333 35.0519 35.459 35.4726L35.0506 37.7887C34.9277 38.4962 34.5325 39.1127 33.9394 39.5223C33.4831 39.8368 32.9518 40 32.4052 40ZM35.2458 33.0677C35.2013 33.0677 35.1569 33.0628 35.1111 33.0552C34.6909 32.9816 34.4103 32.581 34.4839 32.1602L38.4371 9.72126C38.5462 9.09503 38.135 8.49725 37.5203 8.39103L34.886 7.93558C34.4658 7.86338 34.1839 7.46278 34.2568 7.04344C34.329 6.6241 34.7312 6.34083 35.1493 6.41443L37.785 6.86987C39.2393 7.12189 40.2144 8.52086 39.9595 9.98717L36.0063 32.4289C35.9403 32.8031 35.6132 33.0677 35.2458 33.0677Z"
      fill="#5061FA"
    />
    <path
      d="M7.59481 39.9999C7.04753 39.9999 6.51622 39.8375 6.06061 39.523C5.46679 39.1126 5.07092 38.4961 4.94868 37.7859L0.0404934 9.98987C-0.214396 8.52079 0.760713 7.12113 2.21435 6.8698L4.85075 6.41436C5.26747 6.34076 5.66959 6.62264 5.74321 7.04337C5.81614 7.46271 5.53416 7.86331 5.11398 7.93552L2.47827 8.39096C1.86431 8.49718 1.45385 9.09495 1.56219 9.72397L6.46968 37.5193C6.52108 37.8199 6.68707 38.0782 6.9371 38.2504C7.1899 38.4239 7.49897 38.4885 7.80386 38.4378L13.7545 37.3943C14.1789 37.3159 14.5748 37.6012 14.6491 38.0219C14.7227 38.4413 14.4414 38.8419 14.0219 38.9155L8.06917 39.959C7.91012 39.9874 7.75177 39.9999 7.59481 39.9999Z"
      fill="#5061FA"
    />
  </svg>
</template>

<style lang="scss" scoped>
</style>
